import script from "./TemplateTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateTitle.vue?vue&type=script&setup=true&lang=js"

import "./TemplateTitle.vue?vue&type=style&index=0&id=300fb609&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-300fb609"]])

export default __exports__